// extracted by mini-css-extract-plugin
export var alertIcon = "_sr-0";